import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const decemberMap: Array<IPixelMapDay> = [
	{
		status: "below-average",
		reason: `
			Something felt very off today. I can't put my finger on it, but I feel like something bad happened. Even in the afternoon, I felt so anxious. I'm also so sleepy today, I slept at 5 and stood up late with my friends.

			In the evening, I wasn't sure if I was going to go out with my friends or if I'm just going to stay at home and deal with my emotions. I chose the latter, I don't really want to come to my friends and be broken (again, for the nth time) and I just dealt with my emotions as I genuinely would. I'm anxious for tomorrow, but I know what I'm doing and I don't really care about anything anymore.
			
			I tried backreading, and again I remember that there's a reason why I shouldn't do it anymore. Things are way different now, and it shows.
		`,
		spotify: {
			song: "INDUSTRY BABY (feat. Jack Harlow)",
			artist: "Lil Nas X, Jack Harlow",
			link: "https://open.spotify.com/track/27NovPIUIRrOZoCHxABJwK?si=3eb6a8947485475a",
			album: "INDUSTRY BABY (feat. Jack Harlow)"
		},
	},
	{
		status: "above-average",
		reason: `
			I looked forward to something today that didn't really materialize. Hahaha, that's funny. I guess that's what I get for basing my happiness on external things (again). Serves me right, but I'm not down and out or anything. I'm OK.

			In the morning, I was actually surprised that I got invited by my friends for a call and we stayed on call for a few hours while I just played Marvel's Spider-Man Remastered in the background, getting my game to 100% completion. In the afternoon, I took a nap and then woke up to Nathan telling me they'll come over, then cancelling thereafter.

			Since I had nothing to do in the evening, I decided to go outside and getting my friends Mini Brands as a gift to them. I missed going to Greenbelt during the Christmas season and, since I was also here last year with my mom, I went to Smash Burger again just like before. I didn't expect that a single burger would make me full, but I'm glad it did was pretty expensive.

			After eating, I went to the arcades to play Wangan Midnight. I was actually pretty lucky to find an arcade that had 7 (FREE) credits! What the hell? That was a lot of money and someone just left it without second thoughts? Anyway, I got to complete a few story-related races and got to face off several local multiplayer matches.

			When I got home, I decided to upskill for DevOps and learned some Terraform on the side.
		`,
		spotify: {
			song: "California Gurls",
			artist: "Katy Perry",
			link: "https://open.spotify.com/track/1GhbQDYGEOjyFwfT8lojcx?si=694670e756dd416d",
			album: "Teenage Dream"
		},
		resonatedLyrics: [
			"California girls, we're unforgettable",
			"Daisy Dukes, bikinis on top",
			"Sun-kissed skin so hot, we'll melt your popsicle",
			"Oh-oh-oh-oh-oh-oh, oh, oh-oh-oh-oh-oh",
			"California girls, we're undeniable",
			"Fine, fresh, fierce, we got it on lock",
			"West Coast represent, now put your hands up"
		]
	},
	{
		status: "good",
		reason: `
			I got into an argument with someone and I was really disappointed at how this whole thing turned out. I expected that I would go down this path, and I expected to be disappointed, but my God, was I *still* disappointed. Whatever.

			When I was arguing with someone, I had told them that I wish I was found by someone who's more appreciative of me.

			The truth is, I honestly wish I was found by someone who'll properly appreciate me. Someone who doesn't look back at my past faults and even allows me to grow past them. Not someone who keeps me in this weird box. I genuinely pray that I'll meet someone who'll treat me right. And then I remembered this line that my friend shared on their IG Story earlier this day:

			> My heart is at peace knowing that what's meant for me will never miss me and what missed me was never meant for me.

			I personally believe that now. After being here for a long time, being confined in this box with no room to grow or do better, I've slowly realized that I'll thrive with someone else, someday. One day, I'll be arguing with someone and working *through* our flaws and issues together.

			Normally, I'd suffer a lot through arguments like this. I'd have a breakdown, question my self worth, and all that jazz. But now, I don't care. I'll live through this and come out as a stronger person for the one I'm going to eventually meet. I've been on this road long enough to know that it's just pure disappointment, left and right. So I'm gonna do something different: be happy through my struggles. I've been sad, been mad, been vengeful and God knows what, but never happy. LK did tell me long ago that I'm like Sisyphus, and that "one should imagine Sisyphus happy." And, here I am at that tipping point.

			So I handled the argument pretty well, I kept my composure and didn't fight back. After everything was okay, I opened my gift for them and had fun unwapping the Mini Brands on cam for them, showing only my hands. Then I got to play Lethal Company with them and Luan.

			It was fun. Today was fun. I've grown to where I can stomach dejection and look forward to better things.
		`,
		spotify: {
			artist: "The Beatles",
			song: "Twist And Shout",
			link: "https://open.spotify.com/track/5ZBeML7Lf3FMEVviTyvi8l?si=3654e356bc224287",
			album: "Please Please Please Me"
		},
	},
	{
		status: "special",
		icon: "notifications_paused",
		title: "Do Not Disturb",
		reason: `
			The world doesn't need to know what I did today, but it was fun. It was really fun.
		`,
	},
	{
		status: "excellent",
		reason: `
			I had breakfast with my sister in the morning and we talked about what happened yesterday. She was actually pretty understanding and I was glad that she was the only person I could trust with this.

			I feel really sleepy and tired today, but I had fun watching cave diving tragedies with someone during lunchtime.

			Then, after work, she got me to play Sims 4 and I created my character there. In the evening, I slept again and joined call just so we can talk and then they got me to play another game, a horror game titled White Day: A Labyrinth Named School. It was really scary and I haven't finished it yet, but it was really fun.

			My mood is exponentially better, honestly. I feel a-OK.
		`,
		spotify: {
			artist: "aespa",
			song: "Drama",
			link: "https://open.spotify.com/track/5XWlyfo0kZ8LF7VSyfS4Ew?si=a5c67a6f55044656",
			album: "Drama - The 4th Mini Album"
		},
		resonatedLyrics: [
			"I bring, I bring all the",
			"Drama-ma-ma-ma",
			"I bring drama-ma-ma-ma",
			"With my girls in the back",
			"Girls in the back",
			"Drama",
		]
	},
	{
		status: "above-average",
		reason: `
			I got into a call with my RC friends today and I gave them my 2 cents about the recent drama happening within our group. They were surprised at how different my current outlook was, compared to before where I'd cling to people.

			It surprised me, too. I had met so many new people recently, very "interesting" people, to say the least. And I was able to let go of every single one of them without shedding a tear. And now, at a point where I'm ready to loosen my grip on anything in favor of a peaceful life, I can say I've changed. I'm not the same person who'll cry, have emotional breakdowns when someone close is leaving. These days, I feel like I can be okay.
		`,
		spotify: {
			song: "Sour Grapes",
			artist: "LE SSERAFIM",
			link: "https://open.spotify.com/track/6wBpO4Xc4YgShnENGSFA1M?si=935545a899834f75",
			album: "FEARLESS"
		},
	},
	{
		status: "above-average",
		reason: `
			I looked forward to today because it was the last day of the week where I get to work! I'm glad that tomorrow is a holiday. Work wasn't going to let me off so easily and a lot of stuff stacked on my plate, especially in the afternoon.

			In the evening, I played with someone, their brother, and Luan for a few rounds of Lethal Company. It was pretty fun and I recoded the gameplay.
		`,
		spotify: {
			song: "Greedy",
			artist: "Ariana Grande",
			link: "https://open.spotify.com/track/7aLT0tLcS40Penaplqu2cZ?si=229d5af4bf5742f7",
			album: "Dangerous Woman"
		},
	},
	{
		status: "above-average",
		reason: `
			I feel like my energy was just shot today. I stayed up very late with someone and passed out. I had slept and woke up at around 1 p.m.
		
			I was mostly alone today, not sure what I wanted to do, honestly. I had to learn some things about being in the flow state and tried working on my websites for a bit, but not much progress was made. I watched Cars 3 at the end.
		`,
		spotify: {
			song: "Holding Out For A Hero",
			artist: "Frou Frou",
			link: "https://open.spotify.com/track/2wC5a4fViVIwNllXi6sPT0?si=a771353b0a984dba",
			album: "Shrek 2 (Original Motion Picture Soundtrack)"
		},
	},
	{
		status: "excellent",
		title: "Malling and Movies with Meryll",
		icon: "interactive_space",
		reason: `
			My plan for today was to hang out, play mini golf with Max and Meryll today. We had this day planned as our only outing/trip for December, since all of our other plans fell through. When I woke up, I was late for a bit since the call time was around 11 a.m. and it was already around 10:30, so I rushed in getting ready and booked a ride sometime later because the booking process took so long.

			When we got there, Max told us that she wasn't okay and that she should get a check-up at a hospital nearby. Meryll and I tag along as we both get there and, as Max gets checked in and tested, Meryll and I separate from her to talk and hang around the hospital. We got Starbucks and then I proceeded to tell her about how my last Monday went. She was surprised, but honestly supported me, and even encouraged me to an extent. It was a pretty fun conversation with her and Max showed up sometime later to tell us that she's not feeling okay and that she won't be able to push through.

			We all talk about going to SM Megamall instead and I try to persuade Max into not pushing through as she might get weak and pass out, or something else horrible will happen. She decides to just go home instead to prioritize her health as she'll get more tests done tomorrow. So it was just Meryll and I left.

			We both were unsure if we were going to book a ride to the mall or commute, but I ask her if we can just walk by foot instead since the mall is around 20 minutes away. While walking, we talk about various things in life: our current careers, the romantic situations we are in now and the ones before, our friends' relationships, and so on. There was a time where we had stumbled a small place on a bridge that had a fountain and some seats, and we talked about the romantic lives of others and other things. I just looked up at the buildings and found the situation nice.

			When we got to the mall, both of us just had a fun time walking together. We got to Timezone and I taught her how to play Wangan Midnight and how to manuever my manual transmission car. We then bought boba tea and I gossiped to her about my new crush at the company and we both laughed at it. We also got dinner and ate together, then watched The Hunger Games: The Ballad of Songbirds & Snakes. She remarked about how much I react when watching a movie but it was fun.

			By the time the movie was over, my phone's battery had died and we both had problems trying to book a ride home. But we both booked and left at relatively the same time and we both had fun all day.
		`,
		spotify: {
			song: "Fashion Week - Remix",
			artist: "icarus",
			link: "https://open.spotify.com/track/259Q1p3LaDoho6UCYjSvQG?si=5383f51273994750",
			album: "Fashion Week - Remix"
		},
	},
	{
		status: "above-average",
		reason: `
			This day didn't really turn out quite what I expected it to be. But I played Lethal Company with friends in the morning and mostly had the night for myself. So I guess it was pretty much okay.
		`,
	},
	{
		status: "good",
		reason: `
			I had admitted to someone what had happened last week and how things were going for me. I expected it to turn out bad, and I honestly expected to feel disappointed, but life had surprised me and I was pretty surprisingly happy about how things turned out.

			I even played Lethal Company today with someone and Luan again today.
		`,
	},
	{
		status: "above-average",
		reason: `
			I got in a call with Meryll and Max today and had fun in a call with my friends. I also played Sims 4.
		`,
	},
	{
		status: "good",
		icon: "heart_check",
		title: "White Day Finished!",
		reason: `
			I had finished playing White Day today! Someone was watching my entire playthrough and it felt nice to actually complete the game, granted there were some hints and tips that helped me progress faster (because some parts were vague as hell), and I'm personally glad to be out of that horrific high school.

			We also watched a recap of the story and how it actually was supposed to play out because I didn't get the proper ending to the game. It was fun, all things considered, and someone made me jump to the next game.
		`,
		spotify: {
			artist: "Taylor Swift",
			album: "Midnights (The Til Dawn Edition)",
			song: "Bejeweled",
			link: "https://open.spotify.com/track/0VpF6RLdCfPIeYRwMu4tZK?si=cd6b758175ba4d43"
		},
	},
	{
		status: "above-average",
		reason: `
			Not much happened today. It was your usual day for me and, around evening, I went out to eat samgyupsal alone in BGC. I haven't done so in a long time and I missed it. So many things have changed and the menu is entirely new. I loved the beef enoki and it reminded me of how much I missed eating mushrooms.

			When I got home, the evening was fairly-normal.
		`,
		spotify: {
			artist: "K'NAAN",
			song: "Wavin' Flag (Celebration Mix)",
			link: "https://open.spotify.com/track/6MPzzCxr4lKFzT35c1hXNH?si=d1242dcf2e104955",
			album: "Wavin' Flag (Celebration Mix)"
		},
	},
	{
		status: "good",
		icon: "featured_seasonal_and_gifts",
		title: "Christmas Party",
		reason: `
			Today was my company's Christmas party! Honestly? I felt like not just showing up at all for the event. I didn't feel okay enough and my head was in an entirely different space, thinking of other things. I even had friends at the event to help me out. So, getting to the event, it was pretty weird.

			Thankfully, once the event had started, things were pretty much smooth sailing. I got chosen in the best-dressed pageant and got to strut for a bit. My answers were total cringe and I had a weird wardrobe malfunction, which left me embarrassed for the rest of the event. I won a vacuum in the Christmas raffle, and it was okay. Someone in our company was selling 25 kilograms of rice for cheap (that was their raffle prize) and I bought it, and someone else wanted to trade me their 25 kilograms of rice for *my* vacuum cleaner. We didn't need another vacuum cleaner, so I traded it for rice leaving me with **50 kilograms of rice** by the end of the event.
		`,
		spotify: {
			song: "Am I Wrong",
			artist: "Cinderella Original Motion Picture Cast",
			link: "https://open.spotify.com/track/6VJA5XMWwvxB3tgL8fJ6VB?si=350f40de118e4d65",
			album: "Cinderella (Soundtrack from the Amazon Original Movie)"
		},
	},
	{
		status: "special",
		icon: "shield_moon",
		reason: `
			The world doesn't need to know what happened today.
		`,
	},
	{
		status: "average",
		reason: `
			Nothing much happened today. Bummer.

			I did watch a lot of "movie recaps" and I watched one of a Chinese show titled "Reset" and it had a pretty fun, cute storyline that I liked, so that was good.
		`,
	},
	{
		status: "good",
		reason: `
			I met up with someone today and I got my Nintendo Switch back! It's been so long but I honestly missed my Switch, too bad I'm selling it to someone else, though. I also bought a phone today, which seemed nice.

			When I got home, I played Layers of Fear and it got pretty scary, honestly.
		`,
		spotify: {
			song: "Thinking Of You",
			artist: "Katy Perry",
			link: "https://open.spotify.com/track/4ciwlQ4UYHUMj2wuH0ffw6?si=06343ed74a884681",
			album: "One Of The Boys"
		},
	},
	{
		status: "above-average",
		reason: `
			I couldn't sleep at all last night and, the morning I woke up, my body felt like hell.

			Thankfully, in the evening, I felt better and I got to watch the new episodes of Singles Inferno with someone. It was pretty fun and we both were stunned at how much drama had happened, and how long the 2 new episodes were.
		`,
		spotify: {
			song: "Play It Loud",
			artist: "Black Eyed Peas",
			link: "https://open.spotify.com/track/1njouXdrs3W2DlJNhSzFju?si=5e7353cae19848be",
			album: "The Beginning"
		},
	},
	{
		status: "bad",
		reason: `
			The day was normally okay, as normal as things could get but something really bad happened by the evening.
		`,
		spotify: {
			song: "The Feels",
			artist: "TWICE",
			link: "https://open.spotify.com/track/1utDFK1ARQcuZSwapf3cfb?si=03784546f0604276",
			album: "The Feels"
		},
	},
	{
		status: "special",
		icon: "airline_seat_individual_suite",
		reason: `
			I thought today was going to be bad, like really bad. It started off horribly. Come afternoon, however, things were turning out great. I ate good food and got into a pretty interesting situation.

			I liked it. I really, really liked it. It was fun and I don't need to further explain what happened.
		`,
		spotify: {
			song: "Our Song",
			artist: "Taylor Swift",
			link: "https://open.spotify.com/track/1j6gmK6u4WNI33lMZ8dC1s?si=d125a6ef118a456a",
			album: "Taylor Swift"
		},
	},
	{
		status: "above-average",
		title: "Last Day of Work!",
		icon: "next_week",
		reason: `
			Today was the last day of work for the year! So this means I'm just going to lounge around and chill for the rest of the year. Sure, my Christmas break this year wasn't as much as my Christmas break in 2021, but I'm happy to take what I can get. I *really* need the sleep.

			After work, I got to play Layers of Fear and my friends watched me finish it. So that was a fun and creepy game, we both were intrigued by the story. Afterwards, I moved to installing The Last of Us Part I again but they had already slept, so I called it a day.
		`,
		spotify: {
			song: "Sugar",
			artist: "Maroon 5",
			link: "https://open.spotify.com/track/5d6Mjuu2uCGRPYpFjGpCX5?si=3a51cfc6cc2e4f17",
			album: "V"
		},
	},
	{
		status: "good",
		reason: `
			I actually mostly slept today, I think I slept for 14 hours or more. Idk why, I guess I'm just so tired. I only woke up to have lunch and went back to sleeping.

			In the evening, I went to Loy's house just so I can attend their festivities and eat there. I got to talk to his parents again, and met some of his family that I haven't seen in a long time. He showed me his brand-new Steam Deck OLED and, when I got home, I got to play Overwatch with him. Our last game ended on a really good win and it was fun catching up with him.

			Loy did try to ask me about returning to my old IMC group, but I left that far behind me now. At the end of the year, I'm not looking to restore connections. As the new year starts, I'm ready to greet it with the people I already have now and meet new people that the new year might bring.

			I guess I should let life surprise me next year.
		`,
		spotify: {
			song: "All Star",
			artist: "Smash Mouth",
			link: "https://open.spotify.com/track/3cfOd4CMv2snFaKAnMdnvK?si=332a217674d540e1",
			album: "Astro Lounge"
		},
	},
	{
		status: "excellent",
		reason: `
			I got to talk with my friends again today and they were surprised for the gift I gave them. I'm happy that they now have Sons of the Forest and we played the game for a few hours in the afternoon. It was really fun but it was very difficult, so we moved onto other games we could play.

			Since they already have God of War downloaded, they played it on stream and progressed a bit into the opening story. We were on call for actually a long time, which surprised me, and then I had a call with other friends in the evening. After sharing some stories between us, I slept before I got ready to leave to my cousin's house.

			When we got there, they served good food and I personally liked the homemade apple pie. Most of my cousins were there, except for 2, and I got to play games alongside them. I'm surprised that I actually won at a specific game of luck, which made me have the most money won that night. I'm surprised by my luck once again. The day ended when we got home and I got some good rest afterwards.
		`,
		spotify: {
			song: "Thirsty",
			artist: "aespa",
			link: "https://open.spotify.com/track/6nICBdDevG4NZysIqDFPEa?si=5500796610554d15",
			album: "MY WORLD - The 3rd Mini Album"
		},
	},
	{
		status: "above-average",
		title: "A Holiday at Home, Alone",
		icon: "holiday_village",
		reason: `
			I'm surprised that I spent the majority of the day just staying at home. I didn't get into a call with anyone, I didn't have anyone to go out with on Christmas Day either.

			Aside from talking to a few people on Instagram and Discord, I didn't socialize that much with anyone today. Everything seemed quiet, maybe *too quiet*. It's weird, I met so many new people this year and have come across so many things only for me to end up mostly-alone at the end of the year.

			And, maybe I like it this way.

			I'm comfortable with the peace I have today. I didn't stress over anything, nor was I bothered by someone/something. I was perfectly content, I could do whatever I want, and I spent my time how I wanted it to be spent.

			Truth is, I've dealt with a lot of things these past few years and a lot of them had some drama in one form or another. Really weird and painful stuff. From a girl that wanted me to be their someone quickly, to a person messaging me with lazy replies, and a person that seemed nice but didn't pan out, I've been through **A LOT** this year, for nothing. All that struggle for me to not be with anyone. Maybe this is good enough for now. I could use the peace and quiet.
		`,
		spotify: {
			song: "London Bridge",
			artist: "Fergie",
			link: "https://open.spotify.com/track/1GH5tpvz5g1ZGKNBPBWkTm?si=bdffcd0ce1a748ee",
			album: "London Bridge"
		},
		resonatedLyrics: [
			"How come every time you come around",
			"My London London Bridge wanna go down?",
			"Like London London London wanna go down",
			"Like London London London be goin' down like",
			"",
			"How come every time you come around",
			"My London London Bridge wanna go down?",
			"Like London London London wanna go down",
			"Like London London London be goin' down like"
		]
	},
	{
		status: "above-average",
		reason: `
			I got to spend most of my time alone today and watch more of this streamer that I'm into recently. In the evening, I got to play Overwatch 2 with Loy and it was so fun. We were able to catch up, talk and share stories, and have **really good fun** while playing. We had a good streak going on and capped our games with a fun. So that was fun, to say the least.
		`,
		spotify: {
			artist: "DJ Khaled, Justin Bieber, Quavo, Chance the Rapper, Lil Wayne",
			song: "I'm the One",
			link: "https://open.spotify.com/track/3DXncPQOG4VBw3QHh3S817?si=89dcf9c965594ae5",
			album: "Grateful"
		},
	},
	{
		status: "above-average",
		icon: "houseboat",
		title: "Singles Inferno!",
		reason: `
			I got to spend time accompanying my friends today in the morning. I also watched the new episodes of Singles Inferno with them! It was so fun and we were so gripped by the drama unfolding in the new episodes. We watched a fun race between the male contestants and it was really funny and impressive. I also had some Snow Bear candy on my desk today and I chewed on several of them throughout the entire viewing.
		`,
		spotify: {
			song: "Circles",
			artist: "Post Malone",
			link: "https://open.spotify.com/track/21jGcNKet2qwijlDFuPiPb?si=1f547e7168614b4b",
			album: "Hollywood's Bleeding"
		},
	},
	{
		status: "above-average",
		reason: `
			I woke up late but, shortly after waking up, I got called by my friends to watch them play God of War in a call. It feels like I wasted an entire day by sleeping throughout the half of it, but I guess that's okay. I talked to some guy friends about their preferences because a friend made me ask my guy friends what their preferences are.

			In the evening, I watched my friends play again and watched an entertaining documentary about some guy who stole more than a million from the National Australia Bank.
		`,
	},
	{
		status: "above-average",
		reason: `
			I woke up late again, but I had the most vivid dream. I got to watch my friends play God of War in a call for *hours* and it honestly surprised me. After watching them play, we hung around to watch some of the usual caving disaster videos, and then I offered to watch me while I play The Last of Us: Part 1. We got far into the story, nearing the end of it, but the time was cut short when they had some Internet problems. I was supposed to accompany them in the night as well but I genuinely ended up sleeping.
		`,
		spotify: {
			artist: "tripleS",
			song: "Girls' Capitalism",
			link: "https://open.spotify.com/track/2ivVS2ageitCQqnmmMaWoH?si=ac5ef0d5960e4bab",
			album: "LOVElution <ↀ>"
		},
	},
	{
		status: "good",
		reason: `
			I was anxious for most of the day, and I *know* why but I can't *say* why. At least not here. But for most of the day, I was anxious and I felt pressured. It culminated in the afternoon by me being disappointed at an outcome.

			I felt extreme pressure after that, but instead of going ballistic, I was able to channel all that anxiety and pressure into something else. I made a real effort to clean parts of the house today. I looked at old screenshots for a bit and I read a passage from something I used to read back in 2019.

			> Whatever. I'm not against being alone, anyway. It was like this last year. I'll be going through this year just like last year.<br /><br />I'm sure being alone is just my thing.

			I'm alone, but I spent most of my recent years with my friends. And I'm at a point in my life now where it makes sense to start letting go, slowly, of everything I know now. I watched Past Lives once again—fully—to get a complete grasp of the situation I'm in.

			After all that happened today, I had spare time reconnecting with old friends like Exavier, Jaymz, and Sean. I got to tell Exavier how my year went and I'm glad he asked. I'm also happy to play Need for Speed Heat with Jaymz and Sean. I also got to talk to my sister and confide in her about how my life has went recently. Even though my feelings feel hurt, and my heart is weirdly beating for some reason, I'm glad to *still* have people in my life who care and love to spend time with me.
		`,
		spotify: {
			artist: "aespa",
			song: "Drama",
			link: "https://open.spotify.com/track/5XWlyfo0kZ8LF7VSyfS4Ew?si=a5c67a6f55044656",
			album: "Drama - The 4th Mini Album"
		},
	},
	{
		status: "good",
		title: "That Wraps 2023!",
		icon: "event_available",
		reason: `
			I woke up today feeling anxious about some things, but everything was okay by the afternoon. We had a lot of food and celebrations in place for New Year's Eve. In the afternoon, I got into a call with my friends and spent a good chunk of my time with them, watching them play God of War.

			I had fun talking to a lot of my friends, like Kai, Max, Meryll. Even Meryll got to feature my mood calendar posts in her IG Story! I was honestly quite surprised, but happy that so many people took interest in this little project of mine. And now the year's wrapped, I spent most of the evening with my friends and watching them get frustrated with killing a valkyrie. It was fun, I greeted them and other friends as the clock struck midnight.

			And with that, my 2023 journey comes to an end.
		`,
		spotify: {
			song: "I'll Be Home For Quismois",
			artist: "Camilla Cabello",
			link: "https://open.spotify.com/track/6SiKqI0vm3N5NBjdgM2V9m?si=2f5df246ec604cdd",
			album: "I'll Be Home For Christmas"
		},
		resonatedLyrics: [
			"I'll be home for Quismois",
			"You can count on me",
			"Please have snow and mistletoe",
			"And presents under the tree"
		]
	},
];

export default decemberMap;
